import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import useConfrimCookie from './useConfrimCookie'
import useLoginCookie from './useLoginCookie'
import useRoleCookie from './useRoleCookie'
import useAlertModalAtom from './useAlertModalAtom'

const useFetch = () => {
	const navigate = useNavigate()
	const [data, setData] = useState()
	const [loading, setLoading] = useState(false)

	const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()
	const [cookie, , deleteCookie] = useLoginCookie()
	const [, , deleteRoleCookie] = useRoleCookie()
	const [, setAlert] = useAlertModalAtom()

	const request = async (method, path, body, formdata) => {
		setLoading(true)
		const convertResponse = {}

		try {
			const object = {
				method: method,
				headers: {},
			}

			// headers 삽입
			if (confirmCookie) object['headers']['confirm'] = confirmCookie
			if (cookie) object['headers']['token'] = cookie

			// body & formdata 삽입
			if (body) {
				object['headers']['Content-Type'] = 'application/json'
				object['body'] = JSON.stringify(body)
			} else if (formdata) {
				object['body'] = formdata
			}

			// 요청 전송
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}${path}`,
				object
			)

			// 응답 내용 저장
			convertResponse.statusCode = response.status
			convertResponse.data = await response.json()

			// 공통 status code 후처리
			switch (response.status) {
				case 400:
					if (convertResponse.data.error_code === 'LIMIT_FILE_SIZE')
						setAlert('첨부 파일의 용량이 너무 큽니다.')
					break
				case 401:
					if (convertResponse.data.error_code === 'TOKEN_EXPIRED') {
						setAlert('로그인이 만료되었습니다.\n다시 로그인해주세요.')
						deleteCookie()
						deleteRoleCookie()
						navigate('/login')
					} else if (convertResponse.data.error_code === 'TOKEN_INVALID') {
						setAlert('로그인 정보가 올바르지 않습니다.\n다시 로그인해주세요.')
						deleteCookie()
						deleteRoleCookie()
						navigate('/login')
					} else if (convertResponse.data.error_code === 'TOKEN_MISSING') {
						setAlert('로그인이 필요한 서비스 입니다.')
						deleteCookie()
						deleteRoleCookie()
					} else if (convertResponse.data.error_code === 'CONFIRM_EXPIRED') {
						setAlert('연락처 인증 시간이 만료되었습니다.')
						deleteConfirmCookie()
					} else if (convertResponse.data.error_code === 'CONFIRM_INVALID') {
						setAlert('연락처 인증 토큰이 올바르지 않습니다.')
						deleteConfirmCookie()
					} else if (convertResponse.data.error_code === 'CONFIRM_MISSING') {
						setAlert('연락처 인증이 필요합니다.')
						deleteConfirmCookie()
					}
					break
				case 403:
					if (convertResponse.data.error_code === 'UNAUTHORIZED') {
						setAlert('접근 권한이 없습니다.')
						navigate('/')
					}
					break
				case 404:
					if (convertResponse.data.error_code === 'ROUTER_NOT_FOUND')
						setAlert('해당 백엔드 요청은 존재하지 않습니다.')
					break
				case 500:
					if (convertResponse.data.error_code === 'INTERNAL_SERVER_ERROR')
						setAlert(
							'서버에서 알 수 없는 오류가 발생하였습니다.\n관리자에게 문의해주세요.'
						)
					else navigate('/500')
					break
			}

			// 데이터 후처리
			setData(convertResponse)

			if (process.env.REACT_APP_MODE === 'develop') {
				console.group(`${method} ${path}`)
				console.log(body)
				console.log(convertResponse?.statusCode, convertResponse?.data)
				console.groupEnd()
			}
		} catch (err) {
			setAlert('서버 통신 중 문제가 발생하였습니다.')
			console.group(err.message)
			console.log(err.stack)
			console.groupEnd()
		} finally {
			setLoading(false)
		}
	}

	return [data, request, loading]
}

export default useFetch
